const OVERLAY_ID = "page-transition-overlay";
const KEYFRAMES_ID = "page-loader-keyframes";

export default class PageLoader {
  static _ensureKeyframes() {
    if (document.getElementById(KEYFRAMES_ID)) return;
    const style = document.createElement("style");
    style.id = KEYFRAMES_ID;
    style.textContent =
      "@keyframes pageLoaderSpin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}";
    document.head.appendChild(style);
  }

  static show(message) {
    if (document.getElementById(OVERLAY_ID)) return;

    this._ensureKeyframes();

    const overlay = document.createElement("div");
    overlay.id = OVERLAY_ID;
    overlay.setAttribute("role", "status");
    overlay.setAttribute("aria-live", "polite");
    Object.assign(overlay.style, {
      position: "fixed",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      background: "#fff",
      zIndex: "10000",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    });

    const srLabel = document.createElement("span");
    srLabel.textContent = message || "Chargement…";
    Object.assign(srLabel.style, {
      position: "absolute",
      width: "1px",
      height: "1px",
      overflow: "hidden",
      clip: "rect(0,0,0,0)",
    });
    overlay.appendChild(srLabel);

    const logoUrl = window.globalConfig?.logo;
    if (logoUrl) {
      const logo = document.createElement("img");
      logo.src = logoUrl;
      logo.alt = "";
      Object.assign(logo.style, {
        maxWidth: "200px",
        maxHeight: "80px",
        objectFit: "contain",
        marginBottom: "24px",
      });
      overlay.appendChild(logo);
    }

    if (message) {
      const text = document.createElement("p");
      text.textContent = message;
      Object.assign(text.style, {
        margin: "0 0 24px 0",
        fontSize: "16px",
        color: "#555",
        fontFamily: "inherit",
      });
      overlay.appendChild(text);
    }

    const spinner = document.createElement("div");
    spinner.setAttribute("aria-hidden", "true");
    Object.assign(spinner.style, {
      width: "40px",
      height: "40px",
      border: "4px solid #f3f3f3",
      borderRadius: "50%",
      borderTop: "4px solid #555",
      animation: "pageLoaderSpin 1s linear infinite",
    });
    overlay.appendChild(spinner);

    document.body.appendChild(overlay);

    setTimeout(() => PageLoader.hide(), 5000);
  }

  static hide() {
    const overlay = document.getElementById(OVERLAY_ID);
    if (overlay) overlay.remove();
  }
}
